// App.tsx
import { useState, useContext, useEffect } from "react";

import Header from "./component/Header/Header";
import MenuForm from "./component/LeftMenu/MenuForm";
import { Context } from ".";
import "./component/styles/input.css";
import ToastNotification from "./component/Shared/ToastNotification/ToastNotification";
import LoadingPage from "./pages/Loading/LoadingPage";
import { HeadProvider, Link } from "react-head";
import { SEO } from "./component/Helmet/HelmetSEO";
import "./globalStyles/themes/lightColorsThemes.css";
import "./globalStyles/button.css"
import "./globalStyles/globalAppStyle.css"
import Loader from "./component/Shared/Loader/Loader";
import { defaultAppContext, IAppContext } from "./models/ContextModels/IAppContext";
import { SocketContextProvider } from "./contexts/SocketContext";
import { useBreadCrumbContext } from "./contexts/BreadCrumbContext";
import { createContext } from "react";
import { useUserContext } from "./contexts/UserContext";
import AppRoutes from "./routing/AppRouter";
import { useUI } from "./contexts/UiContext";

export const AppContext = createContext<IAppContext>(defaultAppContext);
const App = () => {
    const MAX_ZOOM = 1;
    const MIN_ZOOM = 0.5;

    const { store } = useContext(Context);
    const {
        breadCrumb,
        navPanelHighlight,
        setNavPanelHighlight,
        setBreadCrumb,
        findProject,
        findBoard,
        sideBarProjects,
        archivedProjects,
        navBarInfo,
        isMainPage,
        archivedPage,
        toggleBoard,
        toggleProject,
        getData,
    } = useBreadCrumbContext();
    const { systemUserAccess, pageTitle, iconGetNew } = useUserContext();
    const {
        removeToast,
        showToast,
        toasts,
        currentZoom,
        setCurrentZoom,
        boardScrollPosition,
        setBoardScrollPosition,
        showLoader,
        handleShowLoader,
    } = useUI();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        (async () => {
            if (!store.isActivate) await store.checkActivate(store.user.email);
            if (store.isAuth) {
                await store.getCurrentUser();
                await getData();
                await store.getPersonalSettings();
                await store.checkAvailableModules();
                await store.checkUpgradeCount();
            }
            setIsLoading(false);
        })();
    }, [store.isAuth, store, getData]);

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <div className="main__page">
            <SocketContextProvider>
                <AppContext.Provider
                    value={{
                        systemUserAccess,
                        breadCrumb,
                        setBreadCrumb,
                        sideBarProjects,
                        navBarInfo,
                        toggleProject,
                        toggleBoard,
                        findBoard,
                        findProject,
                        getData,
                        navPanelHighlight,
                        setNavPanelHighlight,
                        currentZoom,
                        setCurrentZoom,
                        MAX_ZOOM,
                        MIN_ZOOM,
                        boardScrollPosition,
                        setBoardScrollPosition,
                        showToast,
                        pageTitle,
                        archivedPage,
                        archivedProjects,
                        handleShowLoader,
                        showLoader,
                        setIsLoading,
                    }}
                >
                    {showLoader && <Loader />}
                    <SEO title={pageTitle} />
                    <HeadProvider>
                        <Link rel="icon" href={iconGetNew} type="image/png" />
                    </HeadProvider>
                    {isMainPage && <MenuForm/>}
                    <div className={`main__page-body ${isMainPage ? "" : "external__page-body"}`}>
                        {isMainPage && <Header/>}
                        <AppRoutes store={store}></AppRoutes>
                        <ToastNotification toasts={toasts} removeToast={removeToast} />
                    </div>
                </AppContext.Provider>
            </SocketContextProvider>
        </div>
    );
};

export default App;
